import { MaskReveal, Rise } from "@/components/site/Reveal";
import { AmazonButton } from "@/components/site/CTA";
import { ASSETS, AMAZON_WWDSS } from "@/lib/site";

export const BookFor = () => {
  return (
    <section
      id="books"
      data-testid="bookfor-section"
      className="relative bg-ink py-32 sm:py-44 overflow-hidden"
    >
      <div className="mx-auto max-w-[1500px] px-6 sm:px-10">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-16 items-center">
          {/* cover — different composition: framed, offset */}
          <Rise className="lg:col-span-5 lg:col-start-1 order-2 lg:order-1">
            <div className="relative w-fit mx-auto lg:mx-0">
              <div className="absolute -inset-6 border border-bone/15" />
              <div className="absolute -bottom-8 -left-8 h-40 w-40 bg-[radial-gradient(circle,rgba(122,26,26,0.25),transparent_70%)] blur-2xl" />
              <img
                src={ASSETS.wwdssCover}
                alt="Women Who Don’t Sit Still cover, editorial framing"
                loading="lazy"
                className="relative cover-shadow w-[68vw] max-w-[320px] sm:max-w-[380px] h-auto"
                data-testid="bookfor-cover"
              />
            </div>
          </Rise>

          {/* copy */}
          <div className="lg:col-span-6 lg:col-start-7 order-1 lg:order-2">
            <p className="font-sans text-xs uppercase tracking-[0.4em] text-rust mb-8">
              Who this book is for
            </p>
            <MaskReveal
              as="h2"
              lines={["FOR THE WOMAN", "WHO KNOWS THERE", "IS MORE."]}
              className="font-serif uppercase leading-[0.9] tracking-tight text-bone text-4xl sm:text-6xl lg:text-7xl"
              testId="bookfor-title"
            />
            <Rise delay={0.2} className="mt-10 max-w-xl space-y-5 font-sans text-base sm:text-lg leading-relaxed text-bone-soft">
              <p>This book is for the woman who can’t ignore it anymore.</p>
              <p>
                The one who knows there is more but keeps talking herself out of
                it.
              </p>
              <p className="text-bone-muted">
                This is not just about riding. It is about what happens when you
                stop settling, stop shrinking and stop waiting for the right
                time. It is about trusting yourself before you have proof, and
                moving before you feel ready.
              </p>
            </Rise>
            <Rise delay={0.35} className="mt-10">
              <AmazonButton href={AMAZON_WWDSS} variant="outline" testId="bookfor-buy-button">
                Get the Book
              </AmazonButton>
            </Rise>
          </div>
        </div>
      </div>
    </section>
  );
};
